import $$ from 'cmn-utils'

const baseUrl = "/api/sys/log/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    }
}